module.exports = __webpack_public_path__ + "img/nav-back-black.5ab1318b.svg";